/**
 * Leave balance tracking (ROADMAP B5, Karan). Not built yet, and depends on
 * B4 for the usage half.
 */
export default function LeaveBalanceTrackerCard() {
    return (
        <div className="space-y-4">
            <div className="ui-card p-4">
                <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-extrabold text-[15px]">Not built yet</h3>
                    <span className="pill bg-sle-tint text-sle">Coming soon</span>
                </div>
                <p className="text-ink-soft text-[13px] mt-2">
                    Vacation, sick and CTO balances are worked out by hand, in one
                    spreadsheet per employee per year. Accrual follows a rule, usage is
                    already written down on the timecards, and a balance is the two
                    subtracted — none of which needs doing by hand.
                </p>
            </div>

            <div className="ui-card p-4">
                <div className="eyebrow mb-2">What it will do</div>
                <ul className="text-[13px] text-ink-soft space-y-1.5 list-disc pl-5">
                    <li>Accrue each person's leave on the monthly schedule.</li>
                    <li>
                        Read usage from the timecards, which already carry{" "}
                        <code>Hours Sick</code> and <code>Hours Vacation</code> per day.
                    </li>
                    <li>Carry the balance forward, monthly, as Karan works today.</li>
                </ul>
                <p className="text-[12px] text-ink-faint mt-3">
                    <strong>Build the Timesheet Generator first.</strong> It is where the
                    usage half comes from: once the timecards are generated, this reads the
                    sheets Pioneer just produced rather than a second hand-kept source that
                    can disagree with them.
                </p>
            </div>
        </div>
    );
}
